import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class SidebarStore {
    showSidebar: boolean = true;
    menuScrollTopValue: number = 0;
    isScrollDown: boolean = false;

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }


    setShowSidebar = (isShowSidebar: boolean) => {
        this.showSidebar = isShowSidebar;
    }

    get getShowSidebar() {
        return this.showSidebar;
    }

    setMenuScroll = (scrollTop: number) => {
        this.menuScrollTopValue = scrollTop;
    }
    get getMenuScroll() {
        return this.menuScrollTopValue;
    }

    handleisScrollDown = () => {
        this.isScrollDown = !this.isScrollDown;
    }
    get getIsScrollDown() {
        return this.isScrollDown;
    }
}